/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
/* eslint-disable no-redeclare */
/* eslint-disable no-undef */
// import comps from "./comps";
import { pinyin, firstColList, tailColList } from "./const";
import { GetTableList } from "../api/databaseTable.js";
import { GetDeptUser } from "../api/user.js";
import { getToken } from "./auth";
import { Object } from "core-js";
/**
 * 获取表单数据库字段
 * @param {*} colList 表单字段
 */
function getColList(colList) {
  let colArr = []; // JSON.parse(JSON.stringify(firstColList));
  firstColList.forEach(item => {
    colArr.push(item);
  });
  colList.forEach(item => {
    colArr.push(item);
  });
  tailColList.forEach(item => {
    colArr.push(item);
  });
  // colArr.concat(colList);
  // colArr.concat(tailColList);
  return colArr;
}

/**
 * 树形数据的搜索方法(获取查询值)
 * @param {*} tree 树结构数据
 * @param {*} id 找到的ID值
 */
function breadthQuery(tree, id) {
  var stark = [];

  stark = stark.concat(tree);

  while (stark.length) {
    var temp = stark.shift();
    if (temp.childNode) {
      stark = stark.concat(temp.childNode);
    }
    if (temp.conditionNodes) {
      for (let i = 0; i < temp.conditionNodes.length; i++) {
        if (temp.conditionNodes[i].childNode) {
          stark = stark.concat(temp.conditionNodes[i].childNode);
        }

        if (temp.conditionNodes[i].nodeId === id) {
          return temp.conditionNodes[i]; //跳出循环
        }
      }

      // temp.conditionNodes.forEach(item => {
      //   if (item.childNode) {
      //     stark = stark.concat(item.childNode);
      //   }
      // });
    }
    if (temp.branchNodes) {
      for (let i = 0; i < temp.branchNodes.length; i++) {
        if (temp.branchNodes[i].childNode) {
          stark = stark.concat(temp.branchNodes[i].childNode);
        }

        if (temp.branchNodes[i].nodeId === id) {
          return temp.branchNodes[i]; //跳出循环
        }
      }

      // temp.conditionNodes.forEach(item => {
      //   if (item.childNode) {
      //     stark = stark.concat(item.childNode);
      //   }
      // });
    }
    if (temp.nodeId === id) {
      return temp;
    }
  }
}

export function breadthQuery2(tree, id) {
  var stark = [];
  var arr = [];
  stark = stark.concat(tree);

  while (stark.length) {
    var temp = stark.shift();
    arr.push(temp);
    if (temp.childNode) {
      stark = stark.concat(temp.childNode);
    }
    if (temp.conditionNodes) {
      for (let i = 0; i < temp.conditionNodes.length; i++) {
        if (temp.conditionNodes[i].childNode) {
          stark = stark.concat(temp.conditionNodes[i].childNode);
        }

        if (temp.conditionNodes[i].nodeId === id) {
          return temp.conditionNodes[i]; //跳出循环
        }
      }

      // temp.conditionNodes.forEach(item => {
      //   if (item.childNode) {
      //     stark = stark.concat(item.childNode);
      //   }
      // });
    }
    if (temp.nodeId === id) {
      return temp;
    }
  }
  return arr;
}

//获取父节点集合
function getParentNodes(tree, id) {
  let node = breadthQuery(tree, id);
  let arr = [];
  for (var i = 0; i < 100; i++) {
    arr.push(node);
    node = breadthQuery(tree, node.prevId);
    console.log("node", node);
    if (!node.prevId) {
      break;
    }
  }
  console.log("conditionNodes", arr);
  return arr;
}

function Guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getTime(time) {
  return time
    ? time
        .replace("T", " ")
        .replace("Z", "")
        .split(".")[0]
    : "";
}

function getBranchApprovalUser(branchApprovalUser) {
  console.log("getBranchApprovalUser", branchApprovalUser);
  if (branchApprovalUser.value) {
    if (branchApprovalUser.value.length > 0) {
      let userarr = branchApprovalUser.value
        .map(v => {
          return v.split("_").length == 2 ? v.split("_")[1] : v.split("_")[0];
        })
        .join();
      //[0].split("_");
      return {
        auditorId: userarr,
        auditorName: branchApprovalUser.label
      };
    } else {
      console.warn("getBranchApprovalUser：未获取到相关人员");
      return {};
    }
  }
}
async function getApprovalUser(arr, branchApprovalUser, applicantUserInfo) {
  let properties = branchApprovalUser;
  branchApprovalUser = branchApprovalUser.actionerRules[0];
  switch (branchApprovalUser.type) {
    case "applicant-department":
      //申请的科室
      //申请人科室主要负责人
      let departmentUsers = await GetDeptUser(applicantUserInfo.depid, 1).then(
        res => {
          return res;
        }
      );
      if (departmentUsers) {
        if (departmentUsers.length > 0) {
          arr.push({
            auditorId: departmentUsers
              .map(v => {
                return v.ID;
              })
              .join(),
            auditorName: departmentUsers
              .map(v => {
                return v.NAME;
              })
              .join()
          });
        } else {
          arr.push({});
          // alert("未获取到申请人科室负责人");
        }
      } else {
        arr.push({});
        // alert("未获取到申请人科室负责人");
      }
      break;
    case "department":
      if (properties.type === 0) {
        console.log("properties.department", properties.department);
        //科室主要负责人
        let deptIdarr = properties.department.deptId.split("_");
        let deptId = deptIdarr.length > 1 ? deptIdarr[1] : deptIdarr[0];
        let departmentUsers = await GetDeptUser(deptId, 1).then(res => {
          return res;
        });
        if (departmentUsers.length > 0) {
          arr.push({
            auditorId: departmentUsers
              .map(v => {
                return v.ID;
              })
              .join(),
            auditorName: departmentUsers
              .map(v => {
                return v.NAME;
              })
              .join()
          });
        } else {
          arr.push({});
          // alert("未获取到科室负责人");
        }
      } else {
        arr.push(getBranchApprovalUser(branchApprovalUser));
      }
      break;
    default:
      arr.push(getBranchApprovalUser(branchApprovalUser));
      break;
  }
  return arr;
}
/** * 获取下一个审批节点相关信息 * @param {*} nodes 模板json * @param {*} id 当前节点Id * @param {*} formDesc 当前表单数据 * @param {*} verifyType 类型 1.审批同意，2.审批不同意 * @param {*} type 当前表单类型 1默认值 2.动态表单值 */
async function getApproval(
  nodes,
  id,
  formDesc,
  verifyType = 1,
  type = 1,
  info = {},
  applicantUserInfo = {},
  isRecursion = false
) {
  let user = getToken();
  let arr = [];
  let parentUser = null;
  let node = {};
  let node1 = {};
  let approvalUser = {};
  let approvalUser1 = {};
  let userarr = [];
  let isFinished = false; //是否结束 0:正常 1：结束
  //当前节点  console.log("nodes", nodes);
  let currentNode = breadthQuery(nodes, id);
  node = currentNode.childNode;
  let conditionInfo = null;
  if (currentNode.prevId) {
    conditionInfo = getIsRouteNode(nodes, id, isRecursion);

    // var parentNodes = getParentNodes(nodes, id);
    // //获取所有父节点
    // let parentCondition = parentNodes.filter(p => p.type === "route");
    // console.log("parentCondition", parentCondition);
    // conditionInfo = parentCondition.length > 0 ? parentCondition[0] : null;
    //获取当前所属最上层条件节点
  }
  if (conditionInfo) {
    console.log("conditionInfo", conditionInfo);
    if (conditionInfo.childNode.properties) {
      // if(conditionInfo.childNode.properties){
      //   alert('缺少审批节点设置');
      //   return;
      // }

      approvalUser1 = conditionInfo.childNode.properties.actionerRules;
      parentUser = await getApprovalUser(
        [],
        conditionInfo.childNode.properties,
        applicantUserInfo
      ).then(res => {
        return res;
      });

      node1 = conditionInfo.childNode;
    } else {
      if (!isRecursion) {
        const rgodicNode = await getApproval(
          nodes,
          conditionInfo.nodeId,
          formDesc,
          verifyType,
          type,
          info,
          applicantUserInfo,
          true
        ).then(res => {
          return res;
        });
        node1 = rgodicNode.node;
        approvalUser1 = rgodicNode.approvalType;
        parentUser = rgodicNode.approval;
      }
    }
  }
  if (currentNode.childNode) {
    let conditionNodes = currentNode.childNode.conditionNodes;
    let branchNodes = currentNode.childNode.branchNodes;
    if (!conditionNodes && !branchNodes) {
      //没有条件
      //   if(currentNode.childNode.properties){
      //     alert('缺少审批节点设置');
      //     return;
      //   }
      approvalUser = currentNode.childNode.properties.actionerRules[0];
      arr = await getApprovalUser(
        arr,
        currentNode.childNode.properties,
        applicantUserInfo
      ).then(res => {
        return res;
      });
      node = currentNode.childNode;
    } else if (branchNodes) {
      var isbreak = false;
      //是否接受for循环
      let approvalArr = [];
      let nodeArr = [];
      for (var i = 0; i < branchNodes.length; i++) {
        var item = branchNodes[i];
        if (item.childNode) {
          if (item.childNode.properties) {
            let branchApprovalUser = item.childNode.properties.actionerRules[0];
            nodeArr.push(item.childNode);
            approvalArr.push(branchApprovalUser);
            arr = await getApprovalUser(
              arr,
              item.childNode.properties,
              applicantUserInfo
            ).then(res => {
              return res;
            });
          } else if (
            item.childNode.branchNodes ||
            item.childNode.conditionNodes
          ) {
            //分支下面还是分支处理方式
            const rgodicNode = await getApproval(
              nodes,
              item.nodeId,
              formDesc,
              verifyType,
              type,
              info,
              applicantUserInfo,
              true
            ).then(res => {
              return res;
            });
            nodeArr = nodeArr.concat(rgodicNode.node);
            approvalArr = approvalArr.concat(rgodicNode.approvalType);
            arr = arr.concat(rgodicNode.approval);
          }
        } else {
          //分支内没有节点处理
          let routeInfo = getIsRouteNode(nodes, item.nodeId, isRecursion);

          if (routeInfo) {
            //找到相关下级节点
            if (routeInfo.childNode.properties) {
              let branchApprovalUser =
                routeInfo.childNode.properties.actionerRules[0];
              nodeArr.push(routeInfo.childNode);
              approvalArr.push(branchApprovalUser);
              arr = await getApprovalUser(
                arr,
                routeInfo.childNode.properties,
                applicantUserInfo
              ).then(res => {
                return res;
              });
            } else {
              const rgodicNode = await getApproval(
                nodes,
                routeInfo.nodeId,
                formDesc,
                verifyType,
                type,
                info,
                applicantUserInfo,
                true
              ).then(res => {
                return res;
              });
              nodeArr = nodeArr.concat(rgodicNode.node);
              approvalArr = approvalArr.concat(rgodicNode.approvalType);
              arr = arr.concat(rgodicNode.approval);
            }
          } else {
            //未找到相关节点
            nodeArr.push(item);
            approvalArr.push({}); //赋值空对象
            arr.push({}); //赋值空对象
          }
        }
      }
      approvalUser = approvalArr;
      node = nodeArr;
    } else {
      //有条件
      var isbreak = false; //是否接受for循环
      for (var i = 0; i < conditionNodes.length; i++) {
        var item = conditionNodes[i];
        console.log("conditionNodes", item);
        let conditions = item.properties.conditions[0]; ////[0];

        //目前支持一种条件判断 完善中
        isbreak = await getConditions(
          conditions,
          userarr,
          formDesc,
          info,
          type,
          item,
          approvalUser,
          arr,
          node,
          applicantUserInfo
        );
        console.log("isbreak", isbreak);

        if (isbreak) {
          let QualifiedInfo = await setQualified(
            item,
            approvalUser,
            arr,
            node,
            applicantUserInfo
          );
          approvalUser = QualifiedInfo.approvalUser;
          arr = QualifiedInfo.arr;
          node = QualifiedInfo.node;
          break;
          //跳出整个for循环
        }
      }
      if (!isbreak) {
        //没有匹配条件或者条件下没有审批节点
        //没有条件
        if (currentNode.childNode.childNode) {
          approvalUser =
            currentNode.childNode.childNode.properties.actionerRules[0];
          arr = await getApprovalUser(
            arr,
            currentNode.childNode.childNode.properties,
            applicantUserInfo
          ).then(res => {
            return res;
          });
        }
        node = currentNode.childNode.childNode;
        console.log("currentNode node", node);
        console.log("currentNode", currentNode);
      }
    }
  } else {
    if (currentNode.prevId) {
      let parentNode = breadthQuery(nodes, currentNode.prevId);
      console.log("parentUser", parentUser);
      console.log("approvalUser1", approvalUser1);
      // if (!parentNode.conditionNodes && !parentNode.branchNodes) {
      //   //不是条件节点的审批对象
      //   // arr.push(parentUser);
      //   // if (conditionInfo) {
      //   //   node = conditionInfo.childNode;
      //   //   console.log("node", node);
      //   //   console.log("获取条件中的节点");
      //   // }
      //   // approvalUser = approvalUser1;
      //   arr = parentUser;
      //   if (conditionInfo) {
      //     node = node1;
      //     console.log("node", node1);
      //     console.log("获取条件中的节点");
      //   }
      //   approvalUser = approvalUser1;
      // } else {
      //是条件节点的审批对象 不做处理
      //分支内没有节点处理
      let routeInfo = getIsRouteNode(nodes, currentNode.nodeId, isRecursion);
      if (routeInfo) {
        //找到相关下级节点
        if (routeInfo.childNode.properties) {
          let branchApprovalUser =
            routeInfo.childNode.properties.actionerRules[0];
          node = routeInfo.childNode;
          approvalUser = branchApprovalUser;
          arr = await getApprovalUser(
            arr,
            routeInfo.childNode.properties,
            applicantUserInfo
          ).then(res => {
            return res;
          });
        } else if (
          routeInfo.childNode.branchNodes ||
          routeInfo.childNode.conditionNodes
        ) {
          const rgodicNode = await getApproval(
            nodes,
            routeInfo.nodeId,
            formDesc,
            verifyType,
            type,
            info,
            applicantUserInfo,
            true
          ).then(res => {
            return res;
          });
          node = rgodicNode.node;
          approvalUser = rgodicNode.approvalType;
          arr = rgodicNode.approval;
        }
      } else {
        //未找到相关节点
        node = currentNode;
        approvalUser = {}; //赋值空对象
        arr = {}; //赋值空对象
      }
      // }
    }
  }
  switch (verifyType) {
    case 2:
      //不同意
      isFinished = true;
      break;
    default:
      isFinished = false;
      break;
  } //arr
  if (Object.keys(approvalUser).length === 0) {
    //未获取到节点
    isFinished = true;
    arr = [];
    console.log("未获取到节点");
    //说明流程结束
  }
  let Nods = {
    isFinished,
    node: node,
    approval: arr,
    approvalType: approvalUser
  };
  console.log("getApproval", Nods);
  return Nods;
}

/**
 * 判断当前分支没有节点情况下，分支外可找到相关节点 找到返回true 没有找到返回false
 * @param {*} nodes 流程整个结果对象
 * @param {*} nodeId 当前节点id
 * @param {*} isRecursion 是否递归
 */
function getIsRouteNode(nodes, nodeId, isRecursion) {
  //分支内没有节点处理
  var parentNodes = getParentNodes(nodes, nodeId);

  console.log("parentNodes", parentNodes);

  //获取所有父节点
  let parentRoute = parentNodes.filter(
    p => p.type === "route" && p.childNode && p.nodeId !== nodeId
  );
  if (isRecursion) {
    parentRoute = parentRoute.filter(p => p.childNode.properties);
  }
  console.log("parentRoute", parentRoute);
  let isbreak = false;

  let parentInfo = {};
  if (parentRoute.length > 0) {
    for (let index = 0; index < parentRoute.length; index++) {
      if (!breadthQuery(parentRoute[index].childNode, nodeId)) {
        //加入下面没有找到相关节点
        parentInfo = parentRoute[index];
        isbreak = true;
        break;
        //跳出整个for循环
      }
    }
    if (isbreak) {
      return parentInfo;
    } else {
      return null;
    }
    // if(breadthQuery(parentRoute[0].childNode,nodeId)){
    //   //加入下面没有找到相关节点
    //   return null;
    // }else{
    //   return parentRoute[0];
    // }
  } else return null;
}
/** * 增加审批对象 * @param {*} formInfo 表单数据 * @param {*} approvalType 审批类型 * @param {*} verifyType 审批类型(0:不跟审批同意不同意管理 1.跟审批类型关联) */
function getApprovalformDesc(formDesc, ApprovalInfo, verifyType = 1) {
  let approvalType = Array.isArray(ApprovalInfo.approvalType)
    ? ApprovalInfo.approvalType[0]
    : ApprovalInfo.approvalType;
  console.log("getApprovalformDesc", ApprovalInfo);
  if (!ApprovalInfo.isFinished) {
    // let name = "人员";
    let auditor = null;
    if (ApprovalInfo.approval.length > 0) {
      auditor = ApprovalInfo.approval;
    }
    // let value = approvalType.value ? approvalType.value : [];
    // switch (approvalType.type) {
    //   case "user-select":
    //     name = "人员";
    //     break;
    //   case "server-center-select":
    //     name = "服务台";
    //     break;
    //   case "receiver-select":
    //     name = "接收方";
    //     break;
    //   case "post-select":
    //     name = "岗位";
    //     break;
    //   case "applicant-department":
    //     name = "申请科室负责人";
    //     break;
    //   case "department":
    //     name = "科室部门";
    //     break;
    // }
    formDesc = setApprovalFormDesc(formDesc, approvalType, verifyType, auditor);
  }
  return formDesc;
}

/**
 * 符合条件的审批人
 * @param {*} item
 * @param {*} approvalUser
 * @param {*} arr
 * @param {*} node
 */
async function setQualified(item, approvalUser, arr, node, applicantUserInfo) {
  if (item.childNode) {
    //条件下有审批节点
    approvalUser = item.childNode.properties.actionerRules[0];
    arr = await getApprovalUser(
      arr,
      item.childNode.properties,
      applicantUserInfo
    ).then(res => {
      return res;
    });
    node = item.childNode;
  } else {
    //没有审批节点
    if (parentUser) {
      arr.push(parentUser);
      node = conditionInfo.childNode;
    }
  }
  return { item, approvalUser, arr, node };
}

//条件功能,判断条件是否符合要求，符合返回true 不符合返回false
async function getConditions(
  conditionsList,
  userarr,
  formDesc,
  info,
  type,
  item,
  approvalUser,
  arr,
  node,
  applicantUserInfo
) {
  let isMultipleConditionBreak = false; //是否跳出多条件判断
  console.log("getConditions", conditionsList);
  for (let index = 0; index < conditionsList.length; index++) {
    const conditions = conditionsList[index];
    switch (conditions.type) {
      case "user": //发起人
        if (conditions.value) {
          userarr = conditions.value.map(v => {
            return v.split("_").length == 2 ? v.split("_")[1] : v.split("_")[0];
          });
          if (userarr.indexOf(applicantUserInfo.userid) > -1) {
            //符合此条件
            //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
          } else isMultipleConditionBreak = true;
        }
        break;
      case "number":
        //数字大小判断
        var fieldVal = 0;
        if (Object.keys(formDesc).length > 0) {
          fieldVal =
            type == 2
              ? formDesc[conditions.field.toLowerCase()]
              : formDesc[conditions.field.toLowerCase()].default;
          //获取字段值
        } else {
          if (info) {
            fieldVal = await GetTableList("", info.tablename, info.taskid).then(
              res => {
                if (res.code == 200) {
                  return res.data[0][conditions.field.toLowerCase()];
                } else {
                  return "";
                }
              }
            );
          } else {
            fieldVal = "";
          }
        }
        if (fieldVal || fieldVal === 0) {
          switch (conditions.key) {
            case "lt":
              //小于
              if (parseInt(conditions.upperBound) > parseInt(fieldVal)) {
                // await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            case "le":
              //小于等于
              if (parseInt(conditions.upperBoundEqual) >= parseInt(fieldVal)) {
                //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            case "eq":
              //等于
              if (parseInt(conditions.boundEqual) == parseInt(fieldVal)) {
                //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            case "gt":
              //大于
              if (parseInt(conditions.lowerBound) < parseInt(fieldVal)) {
                //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            case "ge":
              //大于等于
              if (parseInt(conditions.lowerBoundEqual) <= parseInt(fieldVal)) {
                //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            case "between":
              //介于(两个数之间)
              // eslint-disable-next-line no-case-declarations
              let isOk = false;
              if (conditions.lowerBound && conditions.upperBoundEqual) {
                if (
                  parseInt(conditions.lowerBound) > parseInt(fieldVal) ||
                  parseInt(conditions.upperBoundEqual) <= parseInt(fieldVal)
                ) {
                  isOk = true;
                }
              } else if (
                conditions.lowerBoundEqual &&
                conditions.upperBoundEqual
              ) {
                if (
                  parseInt(conditions.lowerBoundEqual) >= parseInt(fieldVal) ||
                  parseInt(conditions.upperBoundEqual) <= parseInt(fieldVal)
                ) {
                  isOk = true;
                }
              } else if (conditions.lowerBound && conditions.upperBound) {
                if (
                  parseInt(conditions.lowerBound) > parseInt(fieldVal) ||
                  parseInt(conditions.upperBound) < parseInt(fieldVal)
                ) {
                  isOk = true;
                }
              } else if (conditions.lowerBoundEqual && conditions.upperBound) {
                if (
                  parseInt(conditions.lowerBoundEqual) >= parseInt(fieldVal) ||
                  parseInt(conditions.upperBound) < parseInt(fieldVal)
                ) {
                  isOk = true;
                }
              }
              if (isOk) {
                //await setQualified(item,approvalUser,arr,node,applicantUserInfo)
                // isMultipleConditionBreak = true;
              } else isMultipleConditionBreak = true;
              break;
            default:
          }
        }
        break;
    }
    if (isMultipleConditionBreak) {
      break;
      //跳出整个for循环
    }
  }
  return !isMultipleConditionBreak;
}

function setApprovalFormDesc(
  formDesc,
  approvalType,
  verifyType = 1,
  auditor = null,
  index = 0
) {
  let name = "人员";
  let value = approvalType.value ? approvalType.value : [];
  if (auditor) {
    if (Object.keys(auditor[index]).length > 0) {
      value = auditor[index].auditorId.split(",");
      value = value.map(v => {
        return "0_" + v;
      });
    }
  }
  switch (approvalType.type) {
    case "user-select":
      name = "人员";
      break;
    case "server-center-select":
      name = "服务台";
      break;
    case "receiver-select":
      name = "接收方";
      break;
    case "post-select":
      name = "岗位";
      break;
    case "applicant-department":
      name = "申请科室负责人";
      approvalType.type = "user-select";
      break;
    case "department":
      name = "科室部门";
      approvalType.type = "user-select";
      break;
  }
  formDesc = Object.assign(
    {
      approval: {
        label: "审批" + name,
        type: approvalType.type,
        attrs: {
          isContainContact: false,
          multiple: value.length > 0 ? true : false,
          disabled: value.length > 0 ? true : false
        },
        required: true,
        default: value.length > 0 ? value : [],
        vif(data) {
          return verifyType == 0 ? true : data.verifyType === 1;
        }
      }
    },
    formDesc
  );
  return formDesc;
}

function setDynamicFormDesc(formDesc, approvalType, index, verifyType = 1) {
  let name = "人员";
  let value = approvalType.value ? approvalType.value : [];
  switch (approvalType.type) {
    case "user-select":
      name = "人员";
      break;
    case "server-center-select":
      name = "服务台";
      break;
    case "receiver-select":
      name = "接收方";
      break;
    case "post-select":
      name = "岗位";
      break;
    case "applicant-department":
      name = "申请科室负责人";
      break;
    case "department":
      name = "科室部门";
      break;
  }
  let dynamicFormDesc = {};
  dynamicFormDesc["approval" + index] = {
    label: "审批" + name,
    type: approvalType.type,
    attrs: {
      isContainContact: false,
      multiple: approvalType.type === "user-select" ? true : false,
      disabled: value.length > 0 ? true : false
    },
    required: true,
    default: value.length > 0 ? value : [],
    vif(data) {
      return verifyType == 0 ? true : data.verifyType === 1;
    }
  };
  return dynamicFormDesc;
} /** * 获取审批人信息 * @param {*} formDesc 表单数据 * @param {*} ApprovalInfo 审批环节信息 */
function getAuditers(formDesc, ApprovalInfo, index = 0) {
  let approvalType = ApprovalInfo.approvalType;
  console.log("getAuditers approvalType", approvalType);
  console.log("ApprovalInfo approval", ApprovalInfo.approval);
  let approval = {};

  if (ApprovalInfo.approval.length == 0) {
    approval = getAuditerInfo(formDesc, ApprovalInfo, index);
  } else if (ApprovalInfo.approval.length == 1) {
    if (Object.keys(ApprovalInfo.approval[0]).length > 0) {
      approval = ApprovalInfo.approval[0];
    } else {
      approval = getAuditerInfo(formDesc, ApprovalInfo, index);
    }
  } else {
    approval = ApprovalInfo.approval[0];
  }
  console.log("getAuditers approval", approval);
  return approval;
}

/**
 * 获取单条符合的审批人信息
 * @param {*} formDesc
 * @param {*} ApprovalInfo
 * @param {*} index
 */
function getAuditerInfo(formDesc, ApprovalInfo, index = 0) {
  console.log("formDesc['approval'+index]", formDesc["approval" + index]);
  console.log("formDesc.approval", formDesc.approval);
  formDesc.approval = formDesc.approval
    ? formDesc.approval
    : formDesc["approval" + index];
  console.log("formDesc.approval ", formDesc.approval);
  let approvalType = Array.isArray(ApprovalInfo.approvalType)
    ? ApprovalInfo.approvalType[0]
    : ApprovalInfo.approvalType;
  let approval = {};
  switch (approvalType.type) {
    case "user-select":
      approval = {
        auditorId: formDesc.approval[0].ID,
        auditorName: formDesc.approval[0].Name
      };
      break;
    case "server-center-select":
      approval = {
        auditorId: formDesc.approval[0].ID,
        auditorName: formDesc.approval[0].NAME
      };
      break;
    case "receiver-select":
      approval = {
        auditorId: formDesc.approval.Key,
        auditorName: formDesc.approval.Name
      };
      break;
    case "post-select":
      approval = {
        auditorId: formDesc.approval[0].ID,
        auditorName: formDesc.approval[0].Name
      };
      break;
    case "applicant-department":
      approval = {
        auditorId: formDesc.approval[0].ID,
        auditorName: formDesc.approval[0].NAME
          ? formDesc.approval[0].NAME
          : formDesc.approval[0].Name
      };
      break;
    case "department":
      approval = {
        auditorId: formDesc.approval[0].ID,
        auditorName: formDesc.approval[0].NAME
          ? formDesc.approval[0].NAME
          : formDesc.approval[0].Name
      };
      break;
  }
  return approval;
}

// 遍历数组 查找节点的父节点
export function foreachAndSearchDeptParentNode(list, Id) {
  const self = this;
  if (list) {
    for (let value of list) {
      if (Id === value.nodeId) {
        // 找到该节点
        if (value.prevId) {
          // 继续寻找该节点父节点的父节点，以此类推
          self.foreachAndSearchDeptParentNode(this.treeList, value.prevId);
        }
        self.deptIdList.push(value.nodeId);
      }
      if (Id !== value.nodeId) {
        if (value.childNode) {
          self.foreachAndSearchDeptParentNode(value.childNode, Id);
        }
      }
    }
  }
}
export function treeFindPath(tree, func, path = []) {
  if (!tree) return [];
  for (const data of tree) {
    //这里按照你的需求来存放最后返回的内容吧
    path.push(data);
    console.log(data);
    if (func(data)) return path;
    if (data.childNode) {
      const findChildren = treeFindPath(data.childNode, func, path);
      if (findChildren.length) return findChildren;
    }
    path.pop();
  }
  return [];
}
export default {
  chineseToPinYin: function(l1) {
    var l2 = l1.length;
    var I1 = "";
    var reg = new RegExp("[a-zA-Z0-9]");
    for (var i = 0; i < l2; i++) {
      var val = l1.substr(i, 1);
      var name = this.arraySearch(val, pinyin);
      if (reg.test(val)) {
        I1 += val;
      } else if (name !== false) {
        I1 += name;
      }
    }
    I1 = I1.replace(/ /g, "-");
    while (I1.indexOf("--") > 0) {
      I1 = I1.replace("--", "-");
    }
    return I1;
  },
  getColList,
  breadthQuery,
  getParentNodes,
  Guid,
  getApprovalformDesc,
  setApprovalFormDesc,
  setDynamicFormDesc,
  getAuditers,
  getTime,
  getApproval
};
